import styled from 'styled-components';

export const MessageTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 600;
`;

export const MessageHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const MessageDescriptionWrapper = styled.div`
  display: flex;
  padding-left: 32px;
`;

export const InvalidQuestionsWrapper = styled.div`
  display: flex;
  padding: 12px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.red3};
  background: ${({ theme }) => theme.colors.red1};
`;

export const MessageWrapper = styled.div`
  width: 100%;
  padding: 24px 0 24px 20px;
`;

export const ExisitingQuestionWrapper = styled.div`
  display: flex;
  padding: 12px 16px;
  align-items: center;
  gap: 12px;
  width: 100%;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.orange3};
  background: ${({ theme }) => theme.colors.orange1};
`;

export const WarningTextWrapper = styled.div`
  width: 100%;
`;
